<template>
  <div class="home">
    <v-parallax
      :height="`${isMobile() ? '1700' : '1000'}`"
      dark
      src="../assets/main.png"
    >
      <TyperAnimation :isMobile="isMobile()" />
      <PresentationCards />
    </v-parallax>
    <v-row>
      <v-col class="d-flex justify-center">
        <h2 style="font-weight:400">Veja todos os nossos trabalhos!</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-center">
        <div
          id="myMap"
          :style="
            `position:relative;min-width:100vw;height:${
              isMobile() ? '50vh' : '100vh'
            };`
          "
        ></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-center">
        <h2 style="font-weight:400">
          Satisfação de trabalhar com estes clientes
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between flex-wrap mx-4">
        <v-card
          v-for="(ourClient, i) in ourClients"
          :key="i"
          width="110"
          height="110"
          flat
          class="pa-1 d-flex justify-center mb-4 mx-4"
        >
          <v-img :src="getImgUrl(ourClient)" contain />
        </v-card>
      </v-col>
    </v-row>
    <Footer :hasContact="true" />
  </div>
</template>

<script>
import PresentationCards from "@/components/PresentationCards.vue";
import TyperAnimation from "@/components/TyperAnimation.vue";
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      ourClients: [
        "3m.png",
        "abb-logo.png",
        "baxter.png",
        "br.png",
        "cancer.png",
        "cemar.png",
        "cesb.png",
        "cptm.png",
        "eletropaulo.png",
        "embraer.png",
        "jonshon.png",
        "kodak.png",
        "laranjeirao.png",
        "marata.png",
        "metodista.png",
        "monotrilho.png",
        "monsanto.png",
        "pentaplast.png",
        "placo.png",
        "quaglia.png",
        "ralo.png",
        "rohmrhas.png",
        "shell.png",
        "tivit.png",
        "votorantim.png"
      ]
    };
  },
  name: "Home",
  components: {
    Footer,
    PresentationCards,
    TyperAnimation
  },
  methods: {
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
      return toMatch.some(toMatchItem => {
        return navigator.userAgent.match(toMatchItem);
      });
    },
    getImgUrl(pic) {
      return require(`../assets/clients/${pic}`);
    }
  }
};
</script>
